<template>
  <div class="sidebar-nav-ctr">
    <div>
      <img class="menu-logo" src="../assets/images/icon/setup_logo.png" alt="logo" />
    </div>
    <!-- <div class="menu-list">
      <i class="el-icon-user-solid"></i>
    </div>-->
  </div>
</template>

<script>
export default {
  name: 'side-bar-menu'
}
</script>

<style lang="scss">
.sidebar-nav-ctr {
  width: 60px;
  height: 700px;
  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
}
.menu-logo {
  width: 23px;
  height: 37px;
  margin-top: 23px;
  margin-left: 18px;
}
</style>
